import type { PreviewSaveStatus } from './setting-preview.types';

export interface SaveProgressStats {
  total: number;
  completed: number;
  failed: number;
  pending: number;
  queued: number;
  cancelled: number;
  settled: number;
  isActive: boolean;
  isComplete: boolean;
  allSucceeded: boolean;
  progressPercent: number;
}

export const getSaveProgressStats = (
  progressMap: Record<string, PreviewSaveStatus>
): SaveProgressStats => {
  const entries = Object.values(progressMap);
  const total = entries.length;

  let completed = 0;
  let failed = 0;
  let pending = 0;
  let queued = 0;
  let cancelled = 0;
  for (const status of entries) {
    if (status === 'completed') completed++;
    else if (status === 'failed') failed++;
    else if (status === 'pending') pending++;
    else if (status === 'queued') queued++;
    else if (status === 'cancelled') cancelled++;
  }

  const settled = completed + failed + cancelled;
  const isActive = pending > 0 || queued > 0;
  const isComplete = total > 0 && !isActive;
  const allSucceeded = isComplete && failed === 0 && cancelled === 0 && completed === total;
  const progressPercent = total > 0 ? Math.round((settled / total) * 100) : 0;

  return {
    total,
    completed,
    failed,
    pending,
    queued,
    cancelled,
    settled,
    isActive,
    isComplete,
    allSucceeded,
    progressPercent,
  };
};
